import styles from "../../../LoanRequestPage.module.scss";
import { OrderType } from "../../../../../../model/orders/orders";
// import { handleCopy } from "../../../../../../utils";
import { CreditEngineScore } from "../../../../../../model/customer/customer";

type Props = {
	orderDetails: OrderType;
	creditEngineScore?: CreditEngineScore;
};

const FinancialInformationTab = ({ orderDetails, creditEngineScore }: Props) => {
	function getCreditEngineClassName(creditEngineScore: CreditEngineScore | undefined) {
		let creditEngineClassName;

		switch (creditEngineScore?.category) {
			case "No Credit History":
				creditEngineClassName = styles.noCredit;
				break;
			case "No Income Details":
				creditEngineClassName = styles.noIncome;
				break;
			case "Closed with Performing Loans":
				creditEngineClassName = styles.closedWithPerformingLoans;
				break;
			case "No Disbursed Date Reported":
				creditEngineClassName = styles.noDisbursedDate;
				break;
			case "Very High Risk":
				creditEngineClassName = styles.veryHighRisk;
				break;
			case "High Risk":
				creditEngineClassName = styles.highRisk;
				break;
			case "Moderate Risk":
				creditEngineClassName = styles.moderateRisk;
				break;
			case "Low Risk":
				creditEngineClassName = styles.lowRisk;
				break;
			default:
				break;
		}

		return creditEngineClassName;
	}

	return (
		<section className={styles.detailsTabWrapper}>
			<div className={styles.detailsContent}>
				<div className={styles.item}>
					<div className={styles.label}>BVN Status</div>
					<div className={styles.value}><div className={styles.success}>Successfully Verified</div></div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Account Number</div>
					<div className={styles.value}>/</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Account Name</div>
					<div className={styles.value}>/</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Account Connect</div>
					<div className={styles.value}><div className={styles.success}>Successful</div></div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Credit Engine Category</div>
					<div className={styles.value}>{
						(()=> {
							const className = getCreditEngineClassName(creditEngineScore);

							return creditEngineScore?.score !== undefined
							? <div className={`${styles.value} ${styles.pill} ${className}`}>{creditEngineScore.category}</div> 
							: <div className={styles.error}>Failed</div>
						})()
					}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Credit Engine Score</div>
					<div className={styles.value}>{
						(()=> {
							return creditEngineScore?.score !== undefined
							? <div className={styles.value}>{(1 - creditEngineScore.score) * 100}%</div> 
							: <div className={styles.error}>Failed</div>
						})()
					}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Serviceable Loan Amount</div>
					<div className={styles.value}>{
						(() => {
							return creditEngineScore?.serviceableLoanAmount !== undefined && creditEngineScore?.serviceableLoanAmount !== null
							? <div className={styles.value}>{creditEngineScore.serviceableLoanAmount} NGN</div> 
							: <div className={styles.error}>Failed</div>
						})()
					}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Number of Performing Loans</div>
					<div className={styles.value}>{
						(()=> {
							return creditEngineScore?.score !== undefined
							? <div className={styles.value}>{creditEngineScore.numberOfPerformingLoans}</div> 
							: <div className={styles.error}>Failed</div>
						})()
					}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Number of Closed Loans</div>
					<div className={styles.value}>{
						(()=> {
							return creditEngineScore?.score !== undefined
							? <div className={styles.value}>{creditEngineScore.numberOfClosedLoans}</div> 
							: <div className={styles.error}>Failed</div>
						})()
					}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Income API</div>
					<div className={styles.value}><div className={styles.success}>Successful</div></div>
				</div>
				{/* <div className={styles.item}>
					<div className={styles.label}>Mono Customer ID</div>
					<div className={styles.value}>
						<div className={styles.copy} onClick={() => handleCopy("56583493")}>
							56583493 <CopyIcon />
						</div>
					</div>
				</div> */}
			</div>
		</section>
	);
};

export default FinancialInformationTab;

